var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4C9.57012 4 8 5.79438 8 8C8 10.2056 9.57008 12 11.5 12C13.4299 12 15 10.2056 15 8C15 5.79438 13.4299 4 11.5 4ZM11.5 10.7498C10.1733 10.7498 9.09373 9.51626 9.09373 7.99982C9.09373 6.48356 10.1731 5.24979 11.5 5.24979C12.8267 5.24979 13.9063 6.48338 13.9063 7.99982C13.9063 9.51626 12.8267 10.7498 11.5 10.7498Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0C5.159 0 0 5.159 0 11.5C0 17.841 5.159 23 11.5 23C17.841 23 23 17.841 23 11.5C23 5.159 17.841 0 11.5 0ZM17.4316 19.9032C15.7541 21.0908 13.7071 21.7894 11.5 21.7894C9.29286 21.7894 7.24595 21.0908 5.56842 19.9032V19.1262C5.56842 17.0571 7.25183 15.3737 9.3211 15.3737H13.679C15.7483 15.3737 17.4317 17.0571 17.4317 19.1264L17.4316 19.9032ZM18.6372 18.9048C18.5209 16.2704 16.3415 14.163 13.6788 14.163H9.32092C6.65854 14.163 4.47882 16.2704 4.36295 18.9048C2.42049 17.0319 1.21048 14.4047 1.21048 11.4998C1.21048 5.82635 5.82648 1.21035 11.5 1.21035C17.1734 1.21035 21.7894 5.82635 21.7894 11.4998C21.7894 14.4046 20.5794 17.0319 18.6371 18.9048H18.6372Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.129188230c60fd0b4b37e8c08f02e529.svg";
export { ForwardRef as ReactComponent };